import { createRoot, render, useEffect, useState } from '@wordpress/element';
import PricingTable from './PricingTable';

const App = ({ attributes, setAttributes }) => {
	const [activePackage, setActivePackage] = useState('lifetime');
	const {
		annualPricingModel,
		annualPricingCoupons,
		lifetimePricingModel,
		lifetimePricingLink,
		lifetimePricingCoupons,
		discountsModel,
		licenseTooltip,
		freeButtonLink,
		annualPricingLink,
		proButtonLink,
		listItems,
		listItemsProf,
		addOnTitle,
		addOnText,
		addOnTooltipContent,
		addOnPrice,
		pricigPlans,
		singleDomainText,
		discountNumner,
		percentageImageStarter,
		percentageImageProf,
		percentageImage,
		licenseNumberText,
		featureTitle,
		enableDiscount,

		yearlyAgencyPricinglink,
		yearlyAgencyCouponPricinglink,
		yearlyBusinessPricinglink,
		yearlyBusinessCouponPricinglink,
		yearlyGrowthPricinglink,
		yearlyGrowthCouponPricinglink,
		lifetimeAgencyPricinglink,
		lifetimeAgencyCouponPricinglink,
		lifetimeBusinessPricinglink,
		lifetimeBusinessCouponPricinglink,
		lifetimeGrowthPricinglink,
		lifetimeGrowthCouponPricinglink,
		changeActivePkgBtn

	} = attributes;

	const handlePrices = (price, discount, discountLtd, plan) => {
		const getPercentage = getDiscountPercentage(discount);
		// eslint-disable-next-line @wordpress/no-unused-vars-before-return
		const getPercentageLtd = getDiscountPercentage(discountLtd);

		const getDiscountPrice = (cost, discountFormula) => {
			if (!discountFormula) return cost;
			return Math.round(
				cost * parseFloat(`.${100 - discountFormula}`)
			);
		};

		const getSavedPrice = (cost, discountFormula) => {
			if (!discountFormula) return 0;
			return Math.round(cost * parseFloat(`.${discountFormula}`));
		};

		if (plan === 'annual') {
			return {
				discountPrice: getDiscountPrice(price, getPercentage),
				savedPrice: getSavedPrice(price, getPercentage),
				regularPrice: getPercentage ? price : 0,
			};
		} else if (plan === 'lifetime') {
			return {
				discountPrice: getDiscountPrice(price, getPercentageLtd),
				savedPrice: getSavedPrice(price, getPercentageLtd),
				regularPrice: getPercentageLtd ? price : 0,
			};
		}
	};

	const getDiscountPercentage = (str) => {
		if (!str) return;
		const matches = str.match(/(\d+)/);
		if (matches) return matches[0];
	};

	const pricingTableData = [
		{
			id: 'starter',
			name: 'Starter',
			description: '',
			price: annualPricingModel.starter,
			priceLtd: lifetimePricingModel.starter,
			discount: discountsModel.starter,
			discountLtd: discountsModel.starterLtd,
			featureTitle: featureTitle.starter,
			packagePlan: pricigPlans,
			features: listItems,
			link: annualPricingLink.starter,
			linkLtd: lifetimePricingLink.starter,
			coupon: annualPricingCoupons.starter,
			couponLtd: lifetimePricingCoupons.starter,
			buttonText: 'Get Started',
			addOnTitle: addOnTitle,
			addOnText: addOnText,
			addOnTooltipContent: addOnTooltipContent,
			addOnPrice: addOnPrice,
			licenseTooltip: licenseTooltip.starter,
			singleDomain: singleDomainText,
			discountNumner: discountNumner.monthly,
			percentageImage: percentageImageStarter,
			licenseNumberText: licenseNumberText.starter,
			freeDocsTooltip: [
				'Product Bulk Edit',
				'Admin Coupon Support',
				'Delivery Time',
				'Commission Types',
				'Frontend Products',
				'Vendor Management',
				'Powerful Reports',
				'Social Login',
				'2 Premium Module',
				'1 Site License',
				'Ticket Based Support',
			],
			enableDiscount: enableDiscount,
			changeActivePkgBtn: changeActivePkgBtn

		},
		{
			id: 'professional',
			name: 'Professional',
			description: '',
			price: annualPricingModel.professional,
			priceLtd: lifetimePricingModel.professional,
			discount: discountsModel.professional,
			featureTitle: featureTitle.professional,
			packagePlan: pricigPlans,
			features: listItemsProf,
			link: annualPricingLink.professional,
			linkLtd: lifetimePricingLink.professional,
			coupon: annualPricingCoupons.professional,
			couponLtd: lifetimePricingCoupons.professional,
			agencyLink: yearlyAgencyPricinglink.professional,
			businessLink: yearlyBusinessPricinglink.professional,
			growthLink: yearlyGrowthPricinglink.professional,
			agencyLtdLink: lifetimeAgencyPricinglink.professional,
			businessLtdLink: lifetimeBusinessPricinglink.professional,
			growthLtdLink: lifetimeGrowthPricinglink.professional,
			buttonText: 'Get Started',
			addOnTitle: addOnTitle,
			addOnText: addOnText,
			addOnTooltipContent: addOnTooltipContent,
			addOnPrice: addOnPrice,
			licenseTooltip: licenseTooltip.professional,
			singleDomain: '',
			discountNumner: discountNumner.yearly,
			percentageImage: '',
			licenseNumberText: licenseNumberText.professional,
			freeDocsTooltip: [
				'Global Doc Permission Setting',
				'Who can manage permission settings',
				'Assitant Widget - Chatbot',
				'Template & Grid styles',
				'1 Year of Support & Product Update',
				'Instant Answer with AI Chatbot',
			],
			enableDiscount: enableDiscount,
			changeActivePkgBtn: changeActivePkgBtn
		},
	];

	// @TODO: will refactor later
	useEffect(() => {
		const starterPrice = document.querySelector('.starter-price-top');
		const professionalPrice = document.querySelector(
			'.professional-price-top'
		);
		const yrStarter = document.querySelector('.starter-price-top + sub');
		const yrProfessional = document.querySelector(
			'.professional-price-top + sub'
		);

		const weDocsFeaturesWrap = document.querySelector(
			'.wedocs-gblocks-features-wrapper'
		);

		if (starterPrice) {
			if (activePackage === 'lifetime') {
				yrStarter.style.visibility = 'hidden';
				yrProfessional.style.visibility = 'hidden';
				weDocsFeaturesWrap.classList.remove('annual');
				weDocsFeaturesWrap.classList.add('lifetime');

				starterPrice.innerHTML = handlePrices(
					lifetimePricingModel.starter,
					discountsModel.starter,
					discountsModel.starterLtd,
					activePackage
				).discountPrice;

				professionalPrice.innerHTML = handlePrices(
					lifetimePricingModel.professional,
					discountsModel.professional,
					activePackage
				).discountPrice;

			} else if ('annual') {
				yrStarter.style.visibility = 'visible';
				yrProfessional.style.visibility = 'visible';
				weDocsFeaturesWrap.classList.remove('lifetime');
				weDocsFeaturesWrap.classList.add('annual');

				starterPrice.innerHTML = handlePrices(
					annualPricingModel.starter,
					discountsModel.starter,
					discountsModel.starterLtd,
					activePackage
				).discountPrice;

				professionalPrice.innerHTML = handlePrices(
					annualPricingModel.professional,
					discountsModel.professional,
					activePackage
				).discountPrice;


			}
		}
	}, [activePackage]);

	return (
		<>
			<div
				className={`switch-button ${activePackage === 'lifetime' ? 'lifetime' : 'annual'
					}`}
			>
				<span
					className="active"
					style={{
						left: activePackage === 'lifetime' ? '50%' : '14px',
					}}
				></span>
				<button
					className={`switch-button-case left ${activePackage === 'annual' ? 'active-case' : ''
						}`}
					onClick={() => setActivePackage('annual')}
				>
					Yearly
				</button>
				<button
					className={`switch-button-case right ${activePackage === 'lifetime' ? 'active-case' : ''
						}`}
					onClick={() => setActivePackage('lifetime')}
				>
					Lifetime
				</button>

				{
					enableDiscount && (
						percentageImage.url && (
							<div className='perentageImage'>
								{
									percentageImage.url && (
										<img src={percentageImage.url} />
									)
								}
							</div>
						)
					)

				}
			</div>
			{ /* end: Switch button */}

			<div className={`pricing-tables-wrapper ${activePackage}`}>
				{pricingTableData.map((item, index) => (
					<PricingTable
						key={index}
						activePlan={index !== 0 ? activePackage : 'annual'}
						title={item.name}
						discount={
							activePackage === 'lifetime'
								? item.discountLtd
								: item.discount
						}
						description={item.description}
						price={
							handlePrices(
								activePackage === 'lifetime'
									? item.priceLtd
									: item.price,
								item.discount,
								item.discountLtd,
								activePackage
							).discountPrice
						}
						regularPrice={
							handlePrices(
								activePackage === 'lifetime'
									? item.priceLtd
									: item.price,
								item.discount,
								item.discountLtd,
								activePackage
							).regularPrice
						}
						savedPrice={
							handlePrices(
								activePackage === 'lifetime'
									? item.priceLtd
									: item.price,
								item.discount,
								item.discountLtd,
								activePackage
							).savedPrice
						}
						packagesPlan={item.packagePlan}
						features={item.features}
						link={item.link}
						linkLtd={item.linkLtd}
						coupon={item.coupon}
						couponLtd={item.couponLtd}
						buttonText={item.buttonText}
						buttonClasses={item.buttonClasses}
						featureTitle={item.featureTitle}
						licenseTooltip={item.licenseTooltip}
						addOnTitle={item.addOnTitle}
						addOnText={item.addOnText}
						addOnTooltipContent={item.addOnTooltipContent}
						addOnPrice={item.addOnPrice}
						singleDomain={item.singleDomain}
						discountNumner={item.discountNumner}
						percentageImage={item.percentageImage}
						licenseNumberText={item.licenseNumberText}
						freeDocsTooltip={item.freeDocsTooltip}
						enableDiscount={item.enableDiscount}
						agencyLink={item.agencyLink}
						businessLink={item.businessLink}
						growthLink={item.growthLink}
						agencyLtdLink={item.agencyLtdLink}
						businessLtdLink={item.businessLtdLink}
						growthLtdLink={item.growthLtdLink}
						changeActivePkgBtn={item.changeActivePkgBtn}

					/>
				))}
			</div>


		</>
	);
};

const mountWrap = document.querySelector('.wp-block-wedocs-gblocks-pricing');
const blockAttributes = mountWrap.getAttribute('data-block-attributes');

if (createRoot) {
	createRoot(mountWrap).render(
		<App attributes={JSON.parse(blockAttributes)} />
	);
} else {
	render(
		<App attributes={JSON.parse(blockAttributes)} />,
		mountWrap
	);
}
